(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-read-more-wrapper]:not([data-read-more-disabled])').forEach(function (wrapper) {
      var content = wrapper.querySelector('[data-read-more-content]');
      var toggle = wrapper.querySelector('[data-read-more-toggle]');
      var moreLabel = wrapper.querySelector('[data-read-more-label-more]');
      var lessLabel = wrapper.querySelector('[data-read-more-label-less]');

      if (!content || !toggle) return;

      var collapsedHeight = parseInt(wrapper.getAttribute('data-collapsed-height'), 10) || 150;

      content.style.maxHeight = collapsedHeight + 'px';
      content.classList.add('is-collapsed');

      // Si el contenido no supera la altura colapsada, ocultamos el botón
      if (content.scrollHeight <= collapsedHeight + 20) {
        toggle.setAttribute('hidden', 'true');
        content.style.maxHeight = 'none';
        content.classList.remove('is-collapsed');
        return;
      }

      toggle.removeAttribute('hidden');

      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';

        if (expanded) {
          content.style.maxHeight = collapsedHeight + 'px';
          content.classList.add('is-collapsed');
          moreLabel.style.display = 'inline';
          lessLabel.style.display = 'none';
          toggle.setAttribute('aria-expanded', 'false');
          wrapper.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
          content.classList.remove('is-collapsed');
          moreLabel.style.display = 'none';
          lessLabel.style.display = 'inline';
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["text"] && !Shopify.designMode) return;
  try {
    class ReadMoreBlock extends HTMLElement {
    connectedCallback() {
      const wrapper = this.querySelector('[data-read-more-wrapper]');
      const content = this.querySelector('[data-read-more-content]');
      const toggle = this.querySelector('[data-read-more-toggle]');
      if (!wrapper || !content || !toggle) return;

      const collapsedHeight = parseInt(wrapper.dataset.collapsedHeight, 10) || 150;

      content.style.maxHeight = collapsedHeight + 'px';
      content.classList.add('is-collapsed');

      if (content.scrollHeight <= collapsedHeight + 20) {
        toggle.hidden = true;
        content.style.maxHeight = 'none';
        content.classList.remove('is-collapsed');
        return;
      }

      toggle.hidden = false;

      toggle.addEventListener('click', () => {
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        const moreLabel = toggle.querySelector('[data-read-more-label-more]');
        const lessLabel = toggle.querySelector('[data-read-more-label-less]');

        if (isExpanded) {
          content.style.maxHeight = collapsedHeight + 'px';
          content.classList.add('is-collapsed');
          moreLabel.style.display = 'inline';
          lessLabel.style.display = 'none';
          toggle.setAttribute('aria-expanded', 'false');
          wrapper.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
          content.classList.remove('is-collapsed');
          moreLabel.style.display = 'none';
          lessLabel.style.display = 'inline';
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    }
  }

  if (!customElements.get('read-more-block')) {
    customElements.define('read-more-block', ReadMoreBlock);
  }
  } catch(e) { console.error(e); }
})();

})();
